import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Email", -1)
const _hoisted_3 = { class: "col-sm-6" }
const _hoisted_4 = { class: "form-group row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Password", -1)
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "form-group row" }
const _hoisted_8 = { class: "col-sm-6 offset-sm-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary",
  type: "submit"
}, "Sign in", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted ml-4" }, "or", -1)

import { ref, inject } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Auth from "@aws-amplify/auth";
import _ from "lodash";
import moment from "moment-timezone";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignIn',
  setup(__props) {

const store = useStore();
const router = useRouter();
const actProperty: any = inject('actProperty');

const setCognitoUser = (user: any) => {
  store.commit("auth/setCognitoUser", user);
}

const addRequest = (id: string) => {
  store.commit("app/addRequest", id);
}

const removeRequest = (id: string) => {
  store.commit("app/removeRequest", id);
}

const username = ref('');
const password = ref('');

// Methods converted to composition API style
const signIn = async () => {
  try {
    addRequest("signIn");
    const user = await Auth.signIn(username.value, password.value);
    setCognitoUser(user);

    if (
      user.challengeName === "SMS_MFA" ||
      user.challengeName === "SOFTWARE_TOKEN_MFA"
    ) {
      // Confirm your email (or mobile, if SMS_MFA is implemented)
      router.push({ name: "confirm-email" });
    } else if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
      // Choose a new password
      router.push({ name: "complete-new-password" });
    } else {
      // Check if we are allowed to access the CMS (if Cognito Group includes "Administrators" or "Customers")
      const assignedGroups = _.get(
        user,
        'signInUserSession.accessToken.payload["cognito:groups"]',
        []
      );
      const isAllowedAccess = assignedGroups.some((assignedGroup: string) =>
        ["Administrators", "Customers", "Dataentry", "Booking"].includes(
          assignedGroup
        )
      );
      if (isAllowedAccess) {
        // You are signed in
        // TODO redirect to path saved in URL
        const isDataEntry = assignedGroups.some((assignedGroup: string) =>
          ["Dataentry"].includes(assignedGroup)
        );
        const isBooking = assignedGroups.some((assignedGroup: string) =>
          ["Booking"].includes(assignedGroup)
        );
        const isDiaryUser = assignedGroups.some((assignedGroup: string) =>
          ["DiaryUser"].includes(assignedGroup)
        );
        const isBookingManagement = assignedGroups.some((assignedGroup: string) =>
          ["BookingManagement"].includes(assignedGroup)
        );
        if(screen.width <= 760 && isDiaryUser) {
          router.push({ name: "pischeduler", params: { date: moment(new Date()).format("DD-MM-YYYY")} });
        } else if (isDataEntry) {
          router.push({ name: "dereports" });
        } else if (isBooking) {
          router.push({ name: "newbooking" });
        } else if (isBookingManagement) {
          router.push({ name: "management-filters" });
        }  else {
          router.push({ name: "reports" });
        }
      } else {
        await Auth.signOut();
        setCognitoUser(null);
        throw Error(
          "You do not have the required permissions to access this system. Please contact support to arrange access."
        );
      }
    }
  } catch (err: any) {
    if (err.code === "UserNotConfirmedException") {
      // The error happens if the user didn't finish the confirmation step when signing up
      // In this case you need to resend the code and confirm the user
      // About how to resend the code and confirm the user, please check the signUp part
      actProperty.displayError(err);
    } else if (err.code === "PasswordResetRequiredException") {
      // The error happens when the password is reset in the Cognito console
      // In this case you need to call forgotPassword to reset the password
      // Please check the Forgot Password part.
      actProperty.displayError(err);
      resetPassword();
    } else if (
      err.code === "NotAuthorizedException" ||
      err.code === "UserNotFoundException"
    ) {
      // The error happens when the incorrect password is provided
      // or when the supplied username/email does not exist in the Cognito user pool
      actProperty.displayError("Invalid login details");
    } else if (typeof err.message === "string" && err.message.length) {
      actProperty.displayError(err);
    } else {
      actProperty.displayError(
        "An unexpected error occurred, please try again later."
      );
    }
  } finally {
    removeRequest("signIn");
  }
};

const resetPassword = async () => {
  router.push({ name: 'reset-password' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "auth login",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (signIn()), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "email",
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
          "aria-describedby": "usernameHelp"
        }, null, 512), [
          [
            _vModelText,
            username.value,
            void 0,
            { trim: true }
          ]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
          "aria-describedby": "passwordHelp"
        }, null, 512), [
          [_vModelText, password.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("button", {
          class: "btn btn-link ml-3",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (resetPassword()), ["prevent"]))
        }, " Reset your password ")
      ])
    ])
  ], 32))
}
}

})